// 备注：在setinterval中使用aysnc await语法，部分浏览器会报unexpected token function（建议使用.then()）
import axios from 'axios'
import store from "../../../src/store/index"
// import { Toast, Indicator } from 'mint-ui'
import { Toast, Loading  } from 'vant'
var config = require('../../js/config.js')

// 默认请求公共地址
var domainUrl = config.address
// var headers = config.commomHeaders
var headers = {
  'Content-Type': 'application/json'
}

// post请求
var post = function (url, data) {
	if (!data) {
		data = ''
	}
	if (store.state.apitoken !== '') {
    headers.Authorization = store.state.apitoken
	}
	return new Promise(function (resolve, reject) {
		axios({
			method: 'post',
			url: domainUrl + url,
			headers: headers,
			data: data,
			timeout: 6000,
		})
			.then(function (response) {
				resolve(response.data)
			})
			.catch(function (error) {
				console.warn(error)
				hideLoading()
				showToast('连接服务器失败，取消操作请重试！')
				reject(error)
			})
	})
}

// 获取公司信息
var getCompanyInfo = function (data) {
	return post('/Web/Common/getCompanyInfo', data)
}

// 获取小程序码
var getWeiXinQRcode = function (data) {
	return post('/Common/Qrcode/createQrCodeImage', data)
}

// 获取授权的员工部门列表
var getDepartmentList = function (data) {
	return post('/Web/LetterBox/getDepartmentList', data)
}

// 获取员工列表
var getUserListByBox = function (data) {
	return post('/Web/LetterBox/getUserListByBox', data)
}

// 检测手机号用户是否有授权
var checkUserPhone = function (data) {
	return post('/Web/LetterBox/checkUserPhone', data)
}

// 完成快递单号操作
var sendPackageNo = function (data) {
	return post('/Web/LetterBox/sendPackageNo', data)
}

// 取件
var pickup = function (data) {
	return post('/Web/LetterBox/open', data)
}

// 封装toast
var showToast = function (msg) {
	Toast({
		message: msg,
		duration: 2000
	});
}

var showLoading = function (msg) {
	// if (!msg) {
	// 	Loading.open()
	// } else {
	// 	Loading.open(msg)
	// }
	// 避免加框框覆盖整个屏幕
	// document.getElementsByClassName('mint-indicator-mask')[0].setAttribute('style', 'display: none !important')
}

var hideLoading = function () {
	// Loading.close()
}

var interval
function countDown(func) {
	interval = window.setInterval( function () {
		store.state.mail_time--
		// console.log('store.state.mail_time', store.state.mail_time)
		// console.log(store.state.mail_time < 0)
		if (store.state.mail_time < 0) {
			clearInterval(interval)
			func()
		}
	}, 1000)
}
var clearCountDown = function () {
	clearInterval(interval)
}

export {
	getCompanyInfo,
	getWeiXinQRcode,
	getDepartmentList,
	getUserListByBox,
	checkUserPhone,
	sendPackageNo,
	pickup,

	showToast,
	showLoading,
	hideLoading,
	interval,
	countDown,
	clearCountDown,
}



//////////////////
// WEBPACK FOOTER
// ./static/mailBox/js/request.js
// module id = null
// module chunks = 